import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";
import { Checkbox, FormControlLabel } from "@mui/material";

export default function CheckBoxType({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
  handleCheckboxStatus,
  adaptive,
  setCheckQuestion,
  adaptiveQsNo
}) {
  const [responseAttach, setResponseAttach] = useState("");
  const [checkboxes, setCheckboxes] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const [mideaviewer, setMideaviewer] = useState(false);
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handlePdfClick = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment);
      setMideaviewer(true)
    }, 100)
  };
  // console.log("questionsAnswer", questionsAnswer)

  // useEffect(() => {
  //   const initialAnswer = () => {
  //     !questionsAnswer.find((i) => i.question_id === question?.id) &&
  //       setQuestionsAnswer((prev) => [
  //         ...prev,
  //         {
  //           question_id: question?.id,
  //           answer: {
  //             key: " ",
  //             explanation: " ",
  //           },
  //         },
  //       ]);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const handleCheckboxChange = (option) => {
  //   // checkboxes === option?.key
  //   //   ? setCheckboxes(null)
  //   //   : setCheckboxes(option?.key);
  //   // checkboxes === option?.key
  //   //   ? setQuestionsAnswer((prev) =>
  //   //       prev.filter((i) => i.question_id !== question?.id)
  //   //     )
  //   //   : setQuestionsAnswer((prev) => {
  //   //       const prevData = prev.filter((i) => i.question_id !== question?.id);
  //   //       return [
  //   //         ...prevData,
  //   //         {
  //   //           question_id: question?.id,
  //   //           answer: {
  //   //             key: option?.key,
  //   //             explanation: option?.value,
  //   //           },
  //   //         },
  //   //       ];
  //   //     });
  // };
  useEffect(() => {
    const selected = questionsAnswer
      .filter((i) => i?.question_id === question?.id)
      .map((i) => i?.answer?.key);
    setCheckedOptions(selected[0]);
    if (selected.length > 0 && selected[0] !== " ") {
      setCheckQuestion(true);
    } else {
      setCheckQuestion(false);
    }
  }, [questionsAnswer, question?.id]);

  const handleCheckboxChange = (option) => {
    setQuestionsAnswer((prev) => {
      let updatedData = prev.map((item) => {
        if (item.question_id === question?.id) {
          if (item.answer.key === option?.key) {
            return {
              ...item,
              answer: {
                key: "",
                explanation: "",
              },
            };
          } else {
            return {
              ...item,
              answer: {
                key: option?.key,
                explanation: option?.value,
              },
            };
          }
        }
        return item;
      });
      // Update the parent with the current status
      if (!updatedData.some((item) => item.question_id === question?.id)) {
        updatedData.push({
          question_id: question?.id,
          answer: {
            key: option?.key,
            explanation: option?.value,
          },
        });
      }
      return updatedData;
    });
  };


  return (
    <>
      {question && (
        <div>
          <div className="containerBelowQuestion">
            <div className="d-flex justify-content-between">
              <div className="Question">
                {adaptive ? null : `Q${questionNo}.  `}
                {question?.title?.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {index !== 0 && <br />}
                    <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                      {line}
                    </span>
                  </React.Fragment>
                ))}
                {question?.is_mandatory && (
                  <span
                    style={{
                      marginLeft: "20px",
                      color: "#AC1616",
                      fontSize: "10px",
                      fontWeight: "700",
                    }}
                  >
                    *Mandatory
                  </span>
                )}
              </div>
            </div>

            {question?.attachments?.length > 0 &&
              question.attachments.map((attachment, index) => {
                const fileExt = attachment?.split(".").pop()?.toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(fileExt);
                const isDOC = ["doc", "docx",].includes(fileExt);
                const isVideo = fileExt === "mp4";
                const isPdf = fileExt === "pdf";
                const fileName = attachment.replace(/^[^_]*_/, "");
                const shortName =
                  fileName.length > 15 ? fileName.substring(0, 15) + "..." : fileName;


                const icon =
                  iconData?.find((i) => i.extension === fileExt)?.icon || "";

                const fullUrl = IP + attachment.replace(/^\./, "");

                return (
                  <div key={index} className="mt-2">
                    {/* 🖼 IMAGE */}
                    {isImage && (
                      <img
                        src={fullUrl}
                        alt="Attachment"
                        className="mt-3 imageWidthAndHeight"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                      />
                    )}

                    {/* 🎥 VIDEO */}
                    {isVideo && (
                      <div
                        className="d-flex pdfContainer gap-2 p-2"
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center">
                          <img className="extention_icon" src={icon} alt="video" />
                        </div>
                        <div className="w-100">
                          <div className="pdfNameAssessment" title={fileName}>
                            {shortName}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* 📄 PDF */}
                    {(isPdf || isDOC) && (
                      <div
                        className="mt-2"
                        onClick={() =>
                          handlePdfClick(attachment)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex pdfContainerPendingAssessment gap-2 p-2">
                          <div className="d-flex align-items-center">
                            <img className="extention_icon" src={icon} alt="pdf" />
                          </div>
                          <div className="w-100">
                            <div className="pdfNameAssessment" title={fileName}>
                              {shortName}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* 📁 OTHER FILE TYPES */}
                    {!isImage && !isVideo && !isPdf && !isDOC && (
                      <a
                        href={`https://docs.google.com/gview?url=${encodeURIComponent(
                          fullUrl
                        )}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="d-flex pdfContainer gap-2 p-2">
                          <div className="d-flex align-items-center">
                            <img className="extention_icon" src={icon} alt="file" />
                          </div>
                          <div className="w-100">
                            <div
                              className="pdfName"
                              title={attachment.replace(/^[^_]*_/, "")}
                            >
                              {attachment.replace(/^[^_]*_/, "")}
                            </div>
                          </div>
                        </div>
                      </a>
                    )}
                  </div>
                );
              })}

            <div className="mt-4">
              {question?.options?.length > 0 &&
                question?.options?.map((option, index) => {
                  return (
                    <>
                      <div className="d-flex">
                        <div className="d-flex gap-3 w-[65%]">
                          <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", width: "50px" }}>
                            <div className="mr-2">
                              {
                                option?.key + ". "
                              }
                            </div>
                            <input
                              type="checkbox"
                              className="hwCheckbox"
                              checked={
                                questionsAnswer.find(
                                  (i) => i?.question_id === question?.id
                                )?.answer?.key === option?.key || checkedOptions.includes(option?.key)
                              }
                              onChange={() => {
                                setCheckboxes(true);
                                handleCheckboxChange(option);
                              }}
                            />
                          </div>
                          <div
                            className={` ${questionsAnswer.find(
                              (i) => i?.question_id === question?.id
                            )?.answer?.key === option?.key
                              ? "font-semibold text-blue-950 text-[14px]"
                              : "QueOptions"
                              }`}
                          >
                            {option?.value}
                          </div>
                        </div>
                        {questionsAnswer.find(
                          (i) => i?.question_id === question?.id
                        )?.answer?.key === option?.key && (
                            <div className="yourAnswer" style={{ margin: "0px 20px" }}>Your answer</div>
                          )}
                      </div>
                      <div className="ml-6">
                        {option.attachment &&
                          (() => {
                            const ext = option.attachment.split(".").pop().toLowerCase();
                            const isImage = ["jpg", "jpeg", "png"].includes(ext);
                            return isImage ? (
                              <ZoomableImage src={option.attachment} />
                            ) : null;
                          })()}
                      </div>
                    </>
                  )
                })}
            </div>
          </div>
          {mideaviewer && (
            <PdfViewer
              closeMideaviewer={setMideaviewer}
              attachment={responseAttach}
            />
          )}
          {isClicked &&
            (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
              <div className="fullSizeImg ">
                <div className="SubfullSizeImg">
                  <video className="videoPlayer" controls>
                    <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                  </video>
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/DCM-img/crossIcon.svg"
                      alt="Up Arrow"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="fullSizeImg ">
                <div className="SubfullSizeImg">
                  {
                    !isError ? (
                      <>
                        <img
                          className="imgMain"
                          src={IP + responseAttach?.replace(/^\./, "")}
                          alt="Full-size"
                          onError={(e) => {
                            setIsError(true)
                          }}
                        />
                        <div>
                          <img
                            className="crossIconImgQue"
                            onClick={handleClick}
                            src="/images/cross.png"
                            alt="Up Arrow"
                          />
                        </div>
                      </>
                    ) : (
                      <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                        <img
                          onClick={() => {
                            setIsError(false)
                            handleClick()
                          }}
                          src="/images/cross.png"
                          alt="Up Arrow"
                          style={{ position: "absolute", top: "75px", right: "40%" }}
                        />
                        <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                        <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                      </div>
                    )
                  }
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
}
